export const OnboadingIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 15.0002L9 12.0002M12 15.0002C13.3968 14.469 14.7369 13.799 16 13.0002M12 15.0002V20.0002C12 20.0002 15.03 19.4502 16 18.0002C17.08 16.3802 16 13.0002 16 13.0002M9 12.0002C9.53214 10.6197 10.2022 9.29631 11 8.05025C12.1652 6.18723 13.7876 4.6533 15.713 3.59434C17.6384 2.53538 19.8027 1.98662 22 2.00025C22 4.72025 21.22 9.50025 16 13.0002M9 12.0002H4C4 12.0002 4.55 8.97025 6 8.00025C7.62 6.92025 11 8.00025 11 8.00025M4.5 16.5002C3 17.7602 2.5 21.5002 2.5 21.5002C2.5 21.5002 6.24 21.0002 7.5 19.5002C8.21 18.6602 8.2 17.3702 7.41 16.5902C7.02131 16.2193 6.50929 16.0049 5.97223 15.9883C5.43516 15.9717 4.91088 16.154 4.5 16.5002Z"
        stroke={props.color || '#626266'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
